import { useLocation } from "react-router-dom";
import { type ArenaContextFromLocationState } from "../types";

/**
 * A custom hook to retrieve arena "context" data from location state if present.
 */
export const useArenaContextFromLocationState = (): ArenaContextFromLocationState => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  return {
    arenaName: searchParams.get("arenaName") || "",
    logoUrl: searchParams.get("logoUrl") || null,
  };
};
